import { JSXElement, mergeProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import { getAppliedClasses } from '~/utils/commonUtils.ts';

export type TagVariants =
  | 'info'
  | 'success'
  | 'error'
  | 'warning'
  | 'secondary'
  | 'secondary-blue'
  | 'start'
  | 'secondary-brown'
  | 'secondary-orange';

type TagProps = {
  variant?: TagVariants;
  children: JSXElement;
  class?: string;
};

export function Tag(props: TagProps): JSXElement {
  const merged = mergeProps(
    {
      variant: 'info',
      class: ''
    },
    props
  );

  const containerClasses = twMerge(
    'mx-2 py-0.5 px-2 text-xs rounded-sm',
    merged.class
  );
  return (
    <div
      class={twMerge(
        getAppliedClasses({
          'bg-[#0144ff0f] text-[#00259ECB]': merged.variant === 'info',
          'bg-green-50 text-success ': merged.variant === 'success',
          'bg-red-50 text-error ': merged.variant === 'error',
          'bg-[#ffbf0130] text-[#783200cf]': merged.variant === 'warning',
          'bg-[#00003B0D] text-[#0007139F]': merged.variant === 'secondary',
          'bg-[#A04B0018] text-[#522100B9]': merged.variant === 'start',
          'bg-[#01ccff1c] text-[#005681da]':
            merged.variant === 'secondary-blue',
          'bg-[#AB56020F] text-[#512100B9]':
            merged.variant === 'secondary-brown',
          'bg-[#FF91012A] text-[#7B2100C5]':
            merged.variant === 'secondary-orange'
        }),
        containerClasses
      )}
    >
      {merged.children}
    </div>
  );
}
